
import { defineComponent, onMounted, ref,computed,watch,onBeforeUnmount } from 'vue'
// 2026-09-22：个人中心入口读取本人未读数，切换账号后不保留旧通知数量。
import securityApi from '@/api/loginSecurity'
import router from '@/router'
import store from '@/store'
import { useRoute } from 'vue-router'
import { generateTitle } from '@/utils/lang'
export default defineComponent({
  setup() {
    const title=ref('个人资料')
    const route=useRoute()
    const mobileMenuOpen=ref(false)
    const isProfilePage=computed(()=>route.path==='/main/cuscenter/info')
    // 2026-09-30：切换子页时同步手机标题并收起功能卡，入口仍使用原有路由和权限。
    watch(()=>route.path,()=>{
      mobileMenuOpen.value=false
      title.value=route.path==='/main/cuscenter/drawing-patterns'?'来图需求与订单':route.path==='/main/cuscenter/security-notifications'?'系统通知':generateTitle(route.meta.title)
    })
    const securityIdentity=computed(()=>store.getters.token && store.getters.userInfo?.id ? [store.getters.token,store.getters.userInfo.id,store.getters.orgId].join('|') : '')
    const securityUnread=ref<number|null>(null)
    let securityRun=0
    watch(()=>[securityIdentity.value,route.path],async()=>{
      const run=++securityRun,current=securityIdentity.value;securityUnread.value=null
      if(route.path==='/main/cuscenter/security-notifications')title.value='系统通知'
      if(!current)return
      try{const {data}=await securityApi.list();if(run===securityRun && current===securityIdentity.value)securityUnread.value=Number(data.unreadCount)||0}catch{ /* 入口保留待刷新，详情页提供错误和重试。 */ }
    },{immediate:true})
    const noticeCountChanged=(event:Event)=>{const data=(event as CustomEvent).detail;if(data?.identity===[store.getters.orgId,store.getters.userInfo?.id].join(':') && Number.isSafeInteger(data.count) && data.count>=0)securityUnread.value=data.count}
    const noticeReadChanged=async()=>{const run=++securityRun,current=securityIdentity.value;if(!current)return;try{const {data}=await securityApi.list();if(run===securityRun&&current===securityIdentity.value)securityUnread.value=Number(data.unreadCount)||0}catch{/* 网络失败保留上次计数，下一次轮询恢复。 */}}
    window.addEventListener('customer-notification-count',noticeCountChanged)
    window.addEventListener('customer-notifications-changed',noticeReadChanged)
    onBeforeUnmount(()=>{securityRun++;window.removeEventListener('customer-notification-count',noticeCountChanged);window.removeEventListener('customer-notifications-changed',noticeReadChanged)})
    const menuClick=(path,t)=>{
      title.value=t==='drawingPatterns'?'来图需求与订单':t==='securityNotifications'?'系统通知':generateTitle('main.cuscenter.'+t)
      console.log(path)
      if(path==='/main/cuscenter/orders'){
        router.push({  
        path: path, 
        query: {  
          type:1
        }
      });
      }else{
        router.push({  
          path: path,
        });
      }
      
    }
    const orgId=computed(()=>{
      return store.getters.orgId
    })
    const mybranchs=(role)=>{
      router.push({
          path:'/main/cuscenter/branchs', 
          query: {newbrandId:-1,role}
        })
    }
    const back=()=>{
      window.history.back()
    }
    const previliges=computed(()=>{
      return store.getters.previliges
    })
    const vipVisibleFunctions=computed(()=>store.getters.vipVisibleFunctions || {})
    // 2026-08-31：客户等级不足仍可显示升级入口，但分店角色已关闭的功能不会进入可见目录。
    const clientFunctionVisible=(functionName:string)=>Boolean(previliges.value[functionName] || vipVisibleFunctions.value[functionName])
    onMounted(()=>{
      title.value=route.path==='/main/cuscenter/drawing-patterns'?'来图需求与订单':route.path==='/main/cuscenter/security-notifications'?'系统通知':generateTitle(route.meta.title)
    })
    return {
      menuClick,title,back,generateTitle,mybranchs,orgId,previliges,clientFunctionVisible,securityIdentity,securityUnread,mobileMenuOpen,isProfilePage
    }
  }
})
